// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"l3-z","dimensionLabel":"m3-z","styleChooserControlWrapper":"n3-z","styleChooserControl":"o3-z","disabled":"p3-z","giftCard":"q3-z","styleChooserText":"r3-z"};